import { render, staticRenderFns } from "./BudgetForm.vue?vue&type=template&id=e2f67c12&"
import script from "./BudgetForm.vue?vue&type=script&lang=js&"
export * from "./BudgetForm.vue?vue&type=script&lang=js&"
import style0 from "./BudgetForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports